import { User } from './users'
import { RequestStatus } from './response'
import { ID } from '../types/UtilityTypes'

export enum FilePreviewStatus {
    HAS_NO = 0,
    IN_PROGRESS = 10,
    READY = 20,
    ERROR = 30,
}

export interface FileCheckData {
    files: {
        size: number,
    }[]
}

export type FileOwner = 'project' | 'project_work_object' | 'comment'

export interface FileData {
    id: number,
    upload_group_id: number,
    name: string,
    filename: string,
    size: number,
    type: string,
    preview_type?: 'application/pdf' | string,
    preview_status_id: FilePreviewStatus,
    created_at: string,
    deleted: boolean,
    user: User,
    owner_type: FileOwner,
    owner_id: ID,
}

export interface ImageFileData extends FileData {
    width: number,
    height: number,
}

export interface TempFile<T extends File | FileData = File | FileData> {
    id: ID,
    status: RequestStatus,
    data: T,
}

export const isTempFileData = (x: TempFile<File | FileData>): x is TempFile<FileData> => isFileData(x.data)
export const isFileData = (x: FileData | File): x is FileData => Object.prototype.hasOwnProperty.call(x, 'id')
export const isFile = (x: FileData | File): x is File => !isFileData(x)
export const isImage = (file: FileData): file is ImageFileData => (!!file.preview_type?.toLocaleLowerCase().includes('image'))